import { Injectable } from '@angular/core';
import { ApiService, PagedSearch, PagedResult, UtilService, AuthService, AuthUserInfo } from '../../../shared/index';
import { IAkitaTrackingService } from './iakita-tracking.service';

@Injectable()
export class AkitaTrackingService implements IAkitaTrackingService {
  private _utilService: UtilService;
  private _authService: AuthService;

  public constructor(utilService: UtilService, authService: AuthService) {
    this._utilService = utilService;
    this._authService = authService;
  }

  public IntializeTracking = (): void => {};
}
